import { Router } from '@angular/router';
import { Component, Inject, OnDestroy } from '@angular/core';
import { AppSettings } from 'app/service/app-settings.service';
import { AppMenuService } from 'app/service/app-menus.service';
import { StoreStateService, USER_AUTHENTICATION_SERVICE, UserAuthInterface } from 'app/core/services';

@Component({
  selector: 'app-page401',
  templateUrl: './page401.component.html',
  standalone: false
})
export class Page401Component implements OnDestroy {

  constructor(
    private _router: Router,
    private _storeState: StoreStateService,
    private _appMenuService: AppMenuService,
    public appSettings: AppSettings,
    @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface,
  ) {
    this.appSettings.appEmpty = true;
  }

  // goToLogin() {
  //   this._appMenuService.resetCounts();
  //   this._storeState.clearStore();
  //   this._router.navigate(['/account/login']);
  // }


  goToLogin() {
    this._userAuthInterface.logoutUser().subscribe({
      next: () => {
        this._appMenuService.resetCounts();
        this._storeState.clearStore();
        this._router.navigate(['/account/login']);
      },
      error: () => {
        this._appMenuService.resetCounts();
        this._storeState.clearStore();
        this._router.navigate(['/account/login']);
      }
    });
  }

  ngOnDestroy() {
    this.appSettings.appEmpty = false;
  }
}
